import { render, staticRenderFns } from "./MenJinSheBei.vue?vue&type=template&id=53f57a58&scoped=true&"
import script from "./MenJinSheBei.vue?vue&type=script&lang=js&"
export * from "./MenJinSheBei.vue?vue&type=script&lang=js&"
import style0 from "./MenJinSheBei.vue?vue&type=style&index=0&id=53f57a58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f57a58",
  null
  
)

export default component.exports